<style lang="scss" scoped>
.group {
  border-right: 1px solid #dcdfe6;
  height: calc(100% - 60px);
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
  .item {
    font-size: 14px;
    cursor: pointer;
    padding: 15px 20px;
    &.active {
      color: #173bcf;
    }
    &:hover {
      background: #efefef;
    }
  }
}
.btn {
  position: absolute;
  width: 100%;
  color: #173bcf;
  left: 0;
  bottom: 20px;
  text-align: center;
  cursor: pointer;
}
.body {
  border-top: 1px solid #dcdfe6;
  height: 580px;
}
.imageLib {
  /deep/ {
    .el-dialog__body {
      padding: 10px 0 0 0;
    }
  }
}
.list {
  padding: 20px 40px;
  height: 100%;
  overflow: hidden;
  .item {
    position: relative;
    border: 1px solid #dcdfe6;
    margin-bottom: 20px;
    cursor: pointer;
    .image {
      width: 100%;
      height: 165px;
      border-bottom: 1px solid #dcdfe6;
    }
    .text {
      width: 100%;
      padding: 0 6px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      box-sizing: border-box;
    }
    &.active {
      &::after {
        font-family: 'iconfont' !important;
        background: rgba($color: #000000, $alpha: 0.8);
        color: #fff;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        content: '\e607';
        font-size: 20px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.note {
  margin-right: 15px;
  font-size: 12px;
  color: #9b9b9b;
}
</style>

<template>
  <div style="display: inline-block;">
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="选择图片"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="imageLib"
      :append-to-body="true"
    >
      <el-row class="body">
        <el-col :span="6" class="posr h100">
          <div class="group">
            <div
              v-for="(item,index) in groups"
              :key="index"
              class="item"
              :class="{active:groupActive == item.folderId}"
              @click="selectGroup(item.folderId)"
            >{{item.name}} ({{item.count || 0}})</div>
          </div>
          <el-popover placement="top" width="160" v-model="pop">
            <div class="mb10">
              <el-input size="small" v-model="group"></el-input>
            </div>
            <div class="alignr">
              <el-button size="mini" type="text" @click="pop = false">取消</el-button>
              <el-button type="primary" size="mini" @click="addGroup()">确定</el-button>
            </div>
            <div class="btn" slot="reference">+ 新建分组</div>
          </el-popover>
        </el-col>
        <el-col :span="18" class="list">
          <div class="alignr mb20">
            <span class="note">大小不超过5M</span>
            <el-upload
              :show-file-list="false"
              action
              style="display:inline-block"
              :before-upload="beforeFn"
              :http-request="uploadImage"
              accept="image/jpeg, image/png, image/bmp, image/gif"
            >
              <el-button type="info" size="mini">本地上传</el-button>
            </el-upload>
          </div>
          <el-row :gutter="15">
            <el-col :span="6" v-for="(item,index) in list" :key="index">
              <div
                class="item"
                :class="{active:item.materialId == active.materialId}"
                @click="active = item"
              >
                <el-image :src="item.content.thumbUrl" fit="contain" class="image"></el-image>
                <span class="text line1">{{item.content.title}}</span>
              </div>
            </el-col>
            <div v-if="!list.length" class="alignc mb30">暂无数据</div>
          </el-row>
          <div class="alignc">
            <el-pagination
              :current-page.sync="page"
              :page-size="size"
              layout="total, prev, pager, next, jumper"
              :total="totalSize"
              @current-change="getItem"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      groupActive: '',
      groups: [],
      group: '',
      dialog: false,
      pop: false,
      active: {},
      page: 1,
      size: 8,
      list: [],
      totalSize: 0,
    };
  },
  methods: {
    async uploadImage(file) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '2');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      let res2 = await this.$http.post(`/api/${this.id}/material/image`, {
        title: res.name,
        thumburl: res.url,
        folderid: this.groupActive,
      });
      this.getItem();
      return;
    },
    beforeFn(file) {
      if (file.size > 5000 * 1024) {
        this.$message.error(`图片大小不能超过5mb`);
        return false;
      }
      return true;
    },
    confirm() {
      let data = Object.assign({}, this.active);
      this.$emit('confirm', data);
      this.dialog = false;
    },
    async show() {
      this.active = {};
      this.dialog = true;
      await this.getGroup();
      await this.getItem();
    },
    async addGroup() {
      let res = await this.$http.post(`/api/${this.id}/material/folder`, {
        name: this.group,
        type: 2,
      });
      this.pop = false;
      this.getGroup();
    },
    selectGroup(folderId) {
      this.groupActive = folderId;
      this.active = {};
      this.getItem();
    },
    async getItem() {
      let res = await this.$http(`/api/${this.id}/materials`, {
        params: {
          folderId: this.groupActive,
          type: 2,
          page: this.page,
          size: this.size,
        },
      });
      this.totalSize = res.totalSize;
      this.list = res.list;
    },
    async getGroup() {
      let res = await this.$http(`/api/${this.id}/material/folders`, {
        params: {
          type: 2,
        },
      });
      this.groups = res;
      if (res.length) {
        this.groupActive = res[0].folderId;
      }
    },
  },
  mounted() {},
};
</script>
